import { Box } from "@mui/material";
import "../../assets/css/Toolbar.css";
import React from "react";

type ToolbarSlotProps = {
  "data-position"?: string;
};

export interface SimpleToolbarProps {
  customToolbarPadding?: string;
  children?: React.ReactNode;
  customTop?: string;
}

const SimpleToolbar = ({
  customToolbarPadding,
  children,
  customTop,
}: SimpleToolbarProps) => {
  const leftChildren: React.ReactElement<ToolbarSlotProps>[] = [];
  const rightChildren: React.ReactElement<ToolbarSlotProps>[] = [];

  React.Children.forEach(children, (child) => {
    if (React.isValidElement<ToolbarSlotProps>(child)) {
      if (child.props["data-position"] === "right") {
        rightChildren.push(child);
      } else {
        leftChildren.push(child);
      }
    }
  });

  return (
    <Box
      className="toolbar"
      sx={{
        top: customTop ?? 0,
        padding: customToolbarPadding ?? "0px 20px",
        position: "sticky",
      }}
    >
      <Box className="toolbar-left">{leftChildren}</Box>
      <Box className="toolbar-right">{rightChildren}</Box>
    </Box>
  );
};

export { SimpleToolbar };
